import { AuctionBaseCard } from "../components/OmniAuction/AuctionBase/Card";
import React from "react";
import { YouWon } from "../components/YouWon";

const YouWonScreen = () => {
  return (
    <AuctionBaseCard productName="Yerba Mate">
      <YouWon />
    </AuctionBaseCard>
  );
};

export default YouWonScreen;
